import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './LoginForm.scss';
import API_URLS from '../../summaryapi/apiUrls';

const LoginForm = ({ onLogin }) => {
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Check if both name and password fields are filled
    if (!name || !password) {
      setError('Please fill in both fields.');
      return;
    }

    setLoading(true);
    try {
      // API call to PHP backend for admin login
      const response = await axios.post(API_URLS.adminLogin.url, { name, password });

      // Log the response for debugging
      console.log(response.data);
      // Handle success response
      if (response.data.status) { // Use `status` to check for successful login
        // const encodedAdminId = btoa(response.data.admin_id); // Encode admin_id using Base64
        // sessionStorage.setItem('admin_id', response.data.admin_id); // Store encoded admin_id
        //         // Save provider ID and name in cookies
        //         Cookies.set('admin_id', response.data.admin_id, { expires: 7 }); // Expires in 7 days
        // console.log(data.name);
        onLogin(response.data.admin_id); // Call the onLogin function to update auth state
        navigate('/'); // Navigate to Dashboard
      } else {
        // Handle login failure
        setError(response.data.message || 'Login failed. Please try again.');
      }
    } catch (error) {
      // Handle errors during the login process
      console.error('Login error:', error);
      setError('Error occurred during login. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-screen">
        <div className="login-content">
          <h4>Home Services Login</h4>
          <form className="login-form" onSubmit={handleSubmit}>
            <div className="input-group">
              <input
                type="text"
                className="input-field"
                placeholder="User Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                aria-label="Name"
                autoFocus
              />
            </div>
            <div className="input-group">
              <input
                type="password"
                className="input-field"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                aria-label="Password"
              />
            </div>
            {error && <div className="error-message">{error}</div>}
            <button type="submit" className="submit-button-login" disabled={loading}>
              {loading ? (
                <span className="loading-text">Logging in...</span>
              ) : (
                <>
                  <span className="button-text">Login</span>
                  <i className="button-icon fas fa-chevron-right"></i>
                </>
              )}
            </button>
          </form>
        </div>
        <div className="login-background">
          <span className="background-shape shape1"></span>
          <span className="background-shape shape2"></span>
          <span className="background-shape shape3"></span>
          <span className="background-shape shape4"></span>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
